import { EventClient } from "./event";
export class AuviousEventClient extends EventClient {
    get userTopic() {
        return this._userTopic;
    }
    get isSubscribedToUserTopic() {
        return !!this._userTopic;
    }
    constructor(client, assetsLocation, mqttUrl, host, port, path = "/mqtt", sslEnabled, user, pass, refreshConnectionOnUpdatedCredentials = true) {
        super(mqttUrl, assetsLocation, host, port, path, sslEnabled, user, pass, refreshConnectionOnUpdatedCredentials);
        this.refreshConnectionOnUpdatedCredentials = refreshConnectionOnUpdatedCredentials;
        this._client = client;
    }
}
